<template>
  <div class="mit-password-reset-from-link-page mit-page">
    <v-container>
        <v-card v-if="!finished">
            <v-card-title>Reset Password</v-card-title>
            <v-card-text>
              <v-form ref="linkForm" v-model="valid" lazy-validation>
                <div v-if="useChallenge">
                  <v-text-field class="pb-5" v-model="changeModel.challenge" label="Enter Pin" :rules="rules.id"></v-text-field>
                </div>
                <v-text-field v-model="changeModel.newPassword" label="Enter New Password" type="password" :rules="rules.password"></v-text-field>
                <v-text-field v-model="changeModel.newPasswordConfirm" label="Enter New Password Again" type="password" :rules="rules.passwordConfirm"></v-text-field>
                <v-btn color="primary" @click="submit()">Submit</v-btn>
              </v-form>
            </v-card-text>
        </v-card>
        <v-card v-if="finished">
            <v-card-title>{{resultModel.title}}</v-card-title>
            <v-card-text>
                <v-col v-if="loading" class="d-flex justify-center align-center">
                  <v-row>
                    <BaseMitLoading class="pa-10"/>
                  </v-row>
                </v-col>

                <div v-if="!loading" class="pa-10">
                  <div class="pb-10"> {{resultModel.message}}</div>
                  <v-btn v-if="resultModel.success" color="primary" to="/">Go Home</v-btn>
                  <v-btn v-if="!resultModel.success" color="primary" @click="retry()">Retry</v-btn>
                </div>

            </v-card-text>
        </v-card>
      </v-container>
  </div>
</template>

<script>
  import BaseMitLoading from '../../base/components/BaseMitLoading.vue';
  import MitUserManagementService from '../services/MitUserManagementService.js';
  import MitTokenService from '../services/MitTokenService.js';

  export default {
    name: 'MitPasswordResetFromLinkPage',
    components: {
      BaseMitLoading
    },
    data: function() {
      return {
        changeModel:{
          newPassword:'',
          newPasswordConfirm:'',
          challenge:''
        },
        resultModel:{
          success:false,
          title:'',
          link:'',
          message:''
        },
        linkForm: {},
        valid:false,
        rules: {
          //rules for password come from backend since they are needed for api level validation, one set of rules for everyone :)
          id:[
            v => !!v || 'PIN is required',
          ],
          password:[
            v => !!v || 'Password is required',
          ],
          passwordConfirm:[
            v => !!v || 'Confirm Password is required',
            v => this.changeModel.newPassword === this.changeModel.newPasswordConfirm || 'Passwords must match'
          ]
        },
        loading:true,//making the request
        finished:false,
        useChallenge:false
      }
    },
    props: {
      userModel: Object, //comes from route
      userRoles: Object //comes from route
    },
    created() {
      //Get the password validation regex from the api
      MitUserManagementService.getPasswordValidation()
        .then((validation) => {
          for(let x = 0; x < validation.rules.length; x++){
            this.rules.password.push( v => (new RegExp(validation.rules[x].rule)).test(v) || validation.rules[x].message );
          }
        })
        .catch((error) => {
          console.log('Error getting password validation',error);
        });
      this.useChallenge = (typeof MitTokenService.decodeToken(this.$route.query.token).challenge != 'undefined');
    },
    methods: {
      copyLink(){
        let textarea = document.getElementById("mit-reset-link");
        textarea.select();
        document.execCommand("copy");
      },
      retry(){
        //reset the state
        this.finished = false;
        this.resultModel.title = '';
        this.resultModel.message = '';
      },
      submit() {
        if(this.$refs.linkForm.validate()){
          this.finished = true;
          this.loading = true;
          //if nothing is entered send down null.
          if(this.changeModel.challenge == ''){
            this.changeModel.challenge = null;
          }

          MitUserManagementService.passwordResetFromLink(this.changeModel.newPassword, this.changeModel.newPasswordConfirm, this.$route.query.token, this.changeModel.challenge)
          .then((result) => {
            this.loading = false;
            this.resultModel.success = true;
            this.resultModel.title = 'Success';
            this.resultModel.message = result;
          })
          .catch((error) => {
            this.resultModel.success = false;
            this.resultModel.title = 'Error';
            this.resultModel.message = 'Reason: '+error;

            //if there is a message in the error use that instead.
            if(error && error.message)
              this.resultModel.message = 'Reason: '+error.message;

            this.loading = false;
          });
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .mit-app-loading-center {
    display: flex;
    align-items: center;
    justify-content: center;
    height:100vh;
  }
</style>
